import React from 'react';
import useBackendUsers from "../../../../providers/mortgage/useBackendUsers";
import {Alert, Button, Card, Dropdown, Form, Input, Typography} from "antd";
import {
    CheckOutlined,
    CloseOutlined,
    DeleteOutlined,
    EditOutlined,
    LoadingOutlined, SaveOutlined,
    SettingOutlined
} from "@ant-design/icons";
import {gold, green, red} from "@ant-design/colors";
import {ProgressViewState} from "../../../../../models";

function RequestUploadsPanel({section}) {
    const {me, getBySub} = useBackendUsers()
    const [editing, setEditing] = React.useState(false);
    const [saving, setSaving] = React.useState(false);
    const handleRequestMoreSave = async (values) => {
        setSaving(true);
        try {
            await section.mortgage.mutate({
                update: {
                    target: `progress[${section.progress.id}]`,
                    pairs: {
                        alertBody: values.alertBody.split('\n'),
                        alertTitle: values.alertTitle,
                        alertDismissed: false,
                        alertAuthor: me.sub
                    }
                }
            });
            setEditing(false);
            setSaving(false);
        } catch (error) {
            console.error("Error saving request more alert:", error);
        } finally {
            setSaving(false);
        }
    }

    const Message = () => {
        let message = "No Uploads Requested";
        let userActioned = <></>;
        if (section?.progress?.alertTitle) {
            if (section?.progress?.alertAuthor === 'system') {
                message = "Auto-Generated Uploads Request"
            } else if (section?.progress?.alertAuthor) {
                const author = getBySub(section.progress.alertAuthor)
                message = `Uploads Requested by ${author ? author.firstName : 'Unknown User'}`
            }
            if (section.progress.alertDismissed) {
                userActioned = (<><CheckOutlined style={{color: green.primary}}/> Actioned By User</>)
            } else {
                userActioned = (<><CloseOutlined style={{color: red.primary}}/> Not Actioned</>)
            }
        }

        const menuItems = []
        if (section?.progress?.alertTitle) {
            menuItems.push({
                key: 'remove',
                label: section?.progress?.alertAuthor === "system" ? 'Reset Auto Request' : 'Remove Manual Request',
                icon: <DeleteOutlined/>,
                onClick: async () => {
                    await section.mortgage.mutate({
                        update: {
                            target: `progress[${section.progress.id}]`,
                            pairs: {
                                alertBody: null,
                                alertTitle: null,
                                alertDismissed: null,
                                alertAuthor: null
                            }
                        }
                    })
                }
            })
        }
        if (!editing){
            menuItems.push({
                key: 'edit',
                label: section?.progress?.alertTitle ? 'Edit' : 'Add',
                icon: <EditOutlined/>,
                onClick: () => {
                    setEditing(true)
                }
            })
        }

        return (<div className="d-row j-end gap-3">
                <div className="d-col me-auto">
                    <strong>{message}</strong>
                    <Typography.Text strong type="secondary" style={{fontSize: 11}}>
                        {userActioned}
                    </Typography.Text>
                </div>

                <Dropdown placement="bottomRight" menu={{items: menuItems}}>
                    <Button size="small" icon={<SettingOutlined/>}>Manage</Button>


                </Dropdown>
            </div>
        )
    }

    const Description = editing ? (
        <Form initialValues={{
            alertTitle: section?.progress?.alertTitle,
            alertBody: (section?.progress?.alertBody || []).join('\n')
        }} onFinish={handleRequestMoreSave} labelCol={6} wrapperCol={18} className="my-6">
            <Form.Item name="alertTitle" className="mb-9" label="Title">
                <Input/>
            </Form.Item>
            <Form.Item name="alertBody" className="mb-9" label="Body">
                <Input.TextArea autoSize rows={2}/>
            </Form.Item>
            <div className="d-row j-end gap-3">
                <Button onClick={() => setEditing(false)}>
                    Cancel
                </Button>
                <Button icon={saving ? <LoadingOutlined/> : <SaveOutlined/>} htmlType="submit">
                    Save
                </Button>
            </div>

        </Form>

    ) : (<>
        {section?.progress?.alertBody &&(
            <Card styles={{body:{padding: 12, backgroundColor: '#fffae7'}}} size="small" >
                <Typography.Title level={5} className="my-0">{section?.progress?.alertTitle}</Typography.Title>
                {(section?.progress?.alertBody || []).map((line, index) => (
                    <Typography.Text key={index} type="secondary">{line}</Typography.Text>
                ))}
            </Card>
        )}

    </>)

    const fadedProp = section?.progress?.viewState === ProgressViewState.COMPLETE ? {
        style: {
            opacity: 0.4,
            filter: 'grayscale(100%)'
        }
    } : {};
    return <div className="d-col gap-3">
        <Message/>
        {Description}
    </div>

    return <Alert {...fadedProp} className="mt-15" message={Message} description={Description} type="warning" showIcon/>
}

export default RequestUploadsPanel;